import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  notification,
} from 'antd'
import React, { useEffect, useState } from 'react'
import {HASHCHIP_TYPE_SELECT, HistoryHashChipNftRewardRank, NOTIFICATION_DURATION} from '~/common/constants'
import { useQueryState } from '~/common/hooks/useQueryState'
import { useTranslation } from '~/common/hooks/useTranslation'
import Datatable from '~/components/shared-components/Datatable'
import configs from '~/configs'
import { formatAddress, formatTransaction } from '~/helpers/common'
import TimeHelper from '~/helpers/time-helper'
import { usePools } from '~/views/app/redux/hooks/usePools'
import StatistcsDetail from './form'
import staticMethods from 'antd/es/message'

const onSuccess = (message) => {
  notification.success({
    message: message,
    duration: NOTIFICATION_DURATION,
  })
}

const HashchipRedeemed = () => {
  const { t } = useTranslation()
  const { page, pageSize, keyword, setPage, setPageSize, setKeyword } =
    useQueryState()
  const [formDeposit] = Form.useForm()
  const [formWithdraw] = Form.useForm()
  const [formSearch] = Form.useForm()

  const [isModalOpenPreview, setIsModalOpenPreview] = useState({
    isOpenModal: false,
    data: {},
  })
  const [attribute, setAttribute] = useState('');

  const [defaultTable, setDefaultTable] = useState(HASHCHIP_TYPE_SELECT[0])
  const {
    actions,
    data: { isLoadingDeposit, isLoadingWithdraw, histories, isLoading, statisticData, tokenList,  total },
   
  } = usePools()

  const getLinkHashChipNft = (tokenId) => {
    const link = `${process.env.REACT_APP_BASE_URL_WEB}hash-nft-detail/${tokenId}/${process.env.REACT_APP_ADDRESS_HASHCHIP_NFT}/${undefined}/${undefined}/${undefined}`
    return  (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            title={tokenId}
            style={{ color: '#40A9FF' }}
        >
          {tokenId}
        </a>
    )
  }

  const getLinkScanAddress = (address) => {
    let link = `${configs.NETWORK.scan}address/${address}`
    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={link}
            title={address}
            style={{ color: '#40A9FF' }}
        >
          {formatAddress(address)}
        </a>
    )
  }

  const columns = [
    {
      title: t('managementPools.hashChipRedeemed.historyTable.tokenID'),
      dataIndex: 'tokenId',
      key: 'tokenId',
      width: 100,
      render: (tokenId) => {
        return getLinkHashChipNft(tokenId);
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.historyTable.attribute'),
      dataIndex: 'rank',
      key: 'rank',
      width: 100,
      render: (rank) => {
        return HistoryHashChipNftRewardRank[rank]
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.historyTable.time'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 100,
      render: (created_at) => {
        return TimeHelper(created_at)
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.historyTable.to'),
      dataIndex: 'to',
      key: 'to',
      width: 100,
      render: (to) => {
        return getLinkScanAddress(to)
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.historyTable.amount'),
      dataIndex: 'rewardAmount',
      key: 'rewardAmount',
      width: 100,
      render: (rewardAmount) => {
        return rewardAmount + ' OAS'
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.historyTable.txHash'),
      dataIndex: 'transactionHash',
      key: 'transactionHash',
      width: 100,
      render: (transactionHash) => {
        const link = `${configs.NETWORK.scan}tx/${transactionHash}`
        return (
          <a
            style={{ color: '#40A9FF' }}
            href={link}
            title={transactionHash}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formatTransaction(transactionHash)}
          </a>
        )
      },
    },
  ]

  const columns2 = [
    {
      title: t('managementPools.hashChipRedeemed.processTable.tokenID'),
      dataIndex: 'token_id',
      key: 'token_id',
      // width: 100,
      render: (tokenId) => {
        return getLinkHashChipNft(tokenId);
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.processTable.totalRemaining'),
      dataIndex: 'totalRemaining',
      key: 'totalRemaining',
      // width: 100,
      render: (totalRemaining) => {
        return totalRemaining
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.processTable.totalPaid'),
      dataIndex: 'totalPaid',
      key: 'totalPaid',
      // width: 100,
      render: (totalPaid) => {
        return totalPaid
      },
    },
    {
      title: t('managementPools.hashChipRedeemed.processTable.owner'),
      dataIndex: 'owner',
      key: 'owner',
      width: 100,
      render: (owner) => {
        return getLinkScanAddress(owner)
      },
    }
  ]

  const rules = {
    deposit: [
      {
        required: true,
        message: t('validate.required', {
          0: t('managementPools.depositTreasuryPools'),
        }),
      },
      {
        validator: (_, value) => {
          if (value === undefined || value === null || value === '')
            return Promise.resolve()

          const strValue = value.toString()

          // Không cho ký tự đặc biệt (chỉ cho số và dấu chấm, không chữ cái, không dấu + - e v.v.)
          if (!/^\d*\.?\d*$/.test(strValue)) {
            return Promise.reject(new Error(t('validate.noSpecialChars')))
          }

          // Không cho số âm
          if (Number(value) < 0) {
            return Promise.reject(new Error(t('validate.positiveNumber')))
          }

          // Giới hạn tối đa 6 số sau dấu chấm
          const decimalPart = value.toString().split('.')[1]
          if (decimalPart && decimalPart.length > 6) {
            return Promise.reject(new Error(t('validate.max6Decimals')))
          }

          return Promise.resolve()
        },
      },
    ],
    withdraw: [
      {
        required: true,
        message: t('validate.required', {
          0: t('managementPools.withdrawTreasuryPools'),
        }),
      },
      {
        validator: (_, value) => {
          if (value === undefined || value === null || value === '')
            return Promise.resolve()

          const strValue = value.toString()

          // Không cho ký tự đặc biệt (chỉ cho số và dấu chấm, không chữ cái, không dấu + - e v.v.)
          if (!/^\d*\.?\d*$/.test(strValue)) {
            return Promise.reject(new Error(t('validate.noSpecialChars')))
          }

          if (Number(value) < 0) {
            return Promise.reject(new Error(t('validate.positiveNumber')))
          }

          const decimalPart = value.toString().split('.')[1]
          if (decimalPart && decimalPart.length > 6) {
            return Promise.reject(new Error(t('validate.max6Decimals')))
          }

          if(value > statisticData?.data?.totalPools){
            return Promise.reject(new Error(t('validate.greaterThanTotal')))
          }

          return Promise.resolve()
        },
      },
    ],
  }

  useEffect(() => {
  if (defaultTable === HASHCHIP_TYPE_SELECT[0]) {
    actions.getHistoriesHashChipPool({
      page,
      pageSize,
      search: keyword,
      attribute,
    })
  }
}, [page, pageSize, keyword, attribute, defaultTable])

  useEffect(() => {
  if (defaultTable === HASHCHIP_TYPE_SELECT[1]) {
    actions.getProcessHashChipPool({
      page,
      pageSize,
    })
  }
}, [page, pageSize, defaultTable])

  useEffect(() => {
    actions?.getStatisticHashChipPool()
  }, [isLoadingDeposit, isLoadingWithdraw])

  const handleSubmitDeposit = async (values) => {
    actions.depositHashchipPool(
        { amount: values.deposit },
        () => {
          onSuccess(t('managementPools.deposit.success'))
          formDeposit.resetFields()
        },
        (error) => {
          console.error(error)
        }
    )
  };

  const handleSubmitWithdraw = async (values) => {
    actions.withdrawHashChipPool(
        { amount: values.withdraw },
        () => {
          onSuccess(t('managementPools.withdraw.success'))
          formWithdraw.resetFields()
        },
        (error) => {
          console.error(error)
        }
    )
  }

  const showModalPreview = (data) => {
    setIsModalOpenPreview({
      data: data,
      isOpenModal: true,
    })
  }

  const handleCancelPreview = () => {
    setIsModalOpenPreview({
      idArray: [],
      isOpenModal: false,
    })
  }

  const handleSearch = (values) => {
    setKeyword(values?.keyword)
  }

  const onChangeType = (value) => {
    setAttribute('')
    setDefaultTable(value)
  }

  const filterAttribute = (value) => {
    if (value === 'All') {
      setPage(1)
      setAttribute('')
    } else {
        setAttribute(value)
    }
  }

  const options = [
    {value: 'All', label: 'All'},
    ...HistoryHashChipNftRewardRank.map((item, index) => ({
      label: item,
      value: index,
    }))
  ];

  return (
    <div>
      <Row gutter={10}>
        <Col xl={16} md={16} sm={24} xs={24} className="h-full">
          <div
            className="relative p-[20px] h-[240px]"
            style={{
              background:
                'linear-gradient(90deg, rgba(24, 144, 255, 0.4) 0%, rgba(24, 144, 255, 0) 100%)',
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            <Row gutter={10}>
              <Col xl={8} md={8} sm={24} xs={24}>
                <div className="h-full flex flex-col justify-center items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/imgs/common/chip.png`}
                    width={209}
                    height={166}
                    alt=""
                  />
                </div>
              </Col>
              <Col xl={16} md={16} sm={24} xs={24}>
                <div className="grid grid-cols-1 sm:grid-cols-2 h-full min-h-[164px]">
                  <div className="h-full flex flex-col justify-center">
                    <div className="text-[16px] font-bold mb-1">
                      {t('managementPools.hashChipRedeemed.poolBalance')}:
                    </div>
                    <div className="text-[24px] text-[#40A9FF] font-bold">
                      {statisticData?.data?.totalPools} OAS
                    </div>
                  </div>
                  <div className="h-full flex flex-col justify-center">
                    <div className="text-[16px] font-bold mb-1">
                      {t('managementPools.hashChipRedeemed.unclaimed')}
                      :
                    </div>
                    <div className="text-[24px] text-[#40A9FF] font-bold">
                      {statisticData?.data?.unclaimed} OAS
                    </div>
                  </div>
                  <div className="h-full flex flex-col justify-center">
                    <div className="text-[16px] font-bold mb-1">
                      {t('managementPools.hashChipRedeemed.claimed')}:
                    </div>
                    <div className="text-[24px] text-[#40A9FF] font-bold">
                      {statisticData?.data?.claimed} OAS
                    </div>
                  </div>
                  <div className="h-full flex flex-col justify-center">
                    <div className="text-[16px] font-bold mb-1">
                      {t('managementPools.hashChipRedeemed.requiredForClaiming')}:
                    </div>
                    <div className="text-[24px] text-[#FF4D4F] font-bold">
                      {statisticData?.data?.requiredForClaiming} OAS
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col xl={8} md={8} sm={24} xs={24}>
          <Row gutter={10} className="h-[143px]">
            <Col xl={24} md={24} sm={24} xs={24}>
              <Card>
                <Form
                  layout="vertical"
                  onFinish={handleSubmitDeposit}
                  form={formDeposit}
                  translate="yes"
                  autoComplete="off"
                  size="middle"
                  validateTrigger={['onBlur', 'onChange']}
                >
                  <Row gutter={10}>
                    <Col xl={15} md={15} sm={24} xs={24}>
                      <Form.Item
                        label={t('common.btn.deposit')}
                        name="deposit"
                        rules={rules.deposit}
                        labelAlign="left"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xl={9} md={9} sm={24} xs={24}>
                      <div className="flex flex-col">
                        <div className="h-[30px] hidden sm:block"></div>
                        <Button
                          disabled={isLoadingDeposit}
                          loading={isLoadingDeposit}
                          htmlType="submit"
                          type="primary"
                        >
                          {t('common.btn.deposit')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>

                <Form
                  layout="vertical"
                  onFinish={handleSubmitWithdraw}
                  form={formWithdraw}
                  translate="yes"
                  autoComplete="off"
                  size="middle"
                  validateTrigger={['onBlur', 'onChange']}
                >
                  <Row gutter={10}>
                    <Col xl={15} md={15} sm={24} xs={24}>
                      <Form.Item
                        label={t('common.btn.withdraw')}
                        name="withdraw"
                        rules={rules.withdraw}
                        labelAlign="left"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xl={9} md={9} sm={24} xs={24}>
                      <div className="flex flex-col">
                        <div className="h-[30px] hidden sm:block"></div>
                        <Button
                          disabled={isLoadingWithdraw}
                          loading={isLoadingWithdraw}
                          htmlType="submit"
                          type="primary"
                        >
                          {t('common.btn.withdraw')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col span={12} className="h-full box__filter mb-3">
          <div className="flex items-center">
            <div className="mr-2 font__Rexliafree">
              {t('managementPools.hashChipRedeemed.view')}
            </div>
            <Select
              defaultValue={defaultTable}
              className="min-w-[120px] h-full "
              placeholder={t('managementPools.hashChipRedeemed.view')}
              optionFilterProp="children"
              onChange={onChangeType}
              options={HASHCHIP_TYPE_SELECT?.map((data, i) => {
                const typeSelect = {
                  key: i?.toString(),
                  value: data,
                  label: t(`managementPools.hashChipRedeemed.${data}`),
                }
                return typeSelect
              })}
            />
            <Button
              type="primary"
              className="ml-2"
              onClick={() => {
                showModalPreview()
              }}
            >
              {t('managementPools.hashChipRedeemed.statistics')}
            </Button>
          </div>
        </Col>

        {
            defaultTable === HASHCHIP_TYPE_SELECT[0] && (
                <>
                  <Col span={6} className="h-full box__filter mb-3">
                    <div className="flex items-center justify-end">
                      <div className="flex gap-0 sm:gap-3 flex-wrap mb-3 sm:mb-0 w-full sm:justify-end">
                        <Form
                            onFinish={handleSearch}
                            className="w-full sm:w-auto"
                            form={formSearch}
                            translate="yes"
                            autoComplete="off"
                            size="middle"
                            validateTrigger={['onBlur', 'onChange']}
                            requiredMark={false}
                        >
                          <Form.Item
                              className="w-full"
                              label={
                                <span className="font__M__plus font-bold">
                      {t('common.search')}
                    </span>
                              }
                              name="keyword"
                              labelAlign="left"
                          >
                            <Input className="w-full" placeholder={t('common.search')}/>
                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                  </Col>

                  <Col span={6} className="h-full box__filter mb-3">
                    <div className="flex items-center justify-end">
                      <div className="flex gap-0 sm:gap-3 flex-wrap mb-3 sm:mb-0 w-full sm:justify-center">
                        <Form
                            className="w-full sm:w-auto"
                            translate="yes"
                            autoComplete="off"
                            size="middle"
                            validateTrigger={['onBlur', 'onChange']}
                            requiredMark={false}
                        >
                          <Form.Item
                              className="w-full"
                              label={
                                <span className="font__M__plus font-bold">
                      {t('common.attribute')}
                    </span>
                              }
                              name="keyword"
                              labelAlign="left"
                          >
                            <Select
                                className="custom-select"
                                placeholder={t('common.attribute')}
                                options={options}
                                defaultValue="All"
                                onChange={filterAttribute}
                            />
                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </>
            )
        }

        <Col span={24} className="h-full">
          {defaultTable === HASHCHIP_TYPE_SELECT[0] && (
              <Datatable
                  scroll={{x: 1300}}
                  columns={columns}
                  dataSource={histories}
                  showPagination
                  showHeader
                  loading={isLoading}
                  metadata={{
                    perPage: pageSize,
                    setPerPage: setPageSize,
                    page,
                    setPage,
                    total: total,
                    keyword,
                    setKeyword,
                  }}
              />
          )}
          {defaultTable === HASHCHIP_TYPE_SELECT[1] && (
              <Datatable
                  scroll={{x: 1300}}
                  columns={columns2}
                  dataSource={tokenList}
                  showPagination
                  showHeader
                  loading={isLoading}
                  metadata={{
                    perPage: pageSize,
                    setPerPage: setPageSize,
                    page,
                    setPage,
                    total: total,
                    keyword,
                    setKeyword,
                  }}
            />
          )}
        </Col>
      </Row>
      <StatistcsDetail
        action={{
          isModalOpen: isModalOpenPreview.isOpenModal,
          handleCancel: handleCancelPreview,
        }}
        statisticData={statisticData}
        t={t}
        title={t('managementPools.hashChipRedeemed.statisticsDetail.modalTitle')}
      />
    </div>
  )
}

export default HashchipRedeemed
